import { useEffect } from "react";
import { create } from "zustand";

/**
 * Screens with typed-but-not-saved input say so here, so an app update never
 * reloads the page out from under them (pwa/swUpdate.ts waits until clear).
 */
export const useUnsavedStore = create<{ dirty: Record<string, true> }>(() => ({ dirty: {} }));

export function setUnsaved(key: string, dirty: boolean): void {
  useUnsavedStore.setState((s) => {
    const has = key in s.dirty;
    if (dirty === has) return s;
    const next = { ...s.dirty };
    if (dirty) next[key] = true;
    else delete next[key];
    return { dirty: next };
  });
}

export function hasUnsaved(): boolean {
  return Object.keys(useUnsavedStore.getState().dirty).length > 0;
}

/** Mark this screen's form as holding unsaved input while `dirty`. */
export function useUnsavedGuard(key: string, dirty: boolean): void {
  useEffect(() => {
    setUnsaved(key, dirty);
  }, [key, dirty]);
  useEffect(() => () => setUnsaved(key, false), [key]);
}
